import { useState, useCallback, useRef } from 'react'
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, CircularProgress, Chip, Select, MenuItem, FormControl, InputLabel,
  Checkbox, FormControlLabel, Collapse, Tooltip, Alert, Autocomplete,
} from '@mui/material'
import { Add, Edit, Delete, ChevronRight, ExpandMore, DragIndicator } from '@mui/icons-material'
import {
  Business, People, Person, ShoppingBag, Work, Apartment, Flag,
  LocalOffer, Campaign, Handshake, Star, Inventory, AttachMoney,
  LocationOn, Phone, Email, CalendarToday, Description, Security,
  Dashboard, Groups, TrendingUp, Category, Receipt, Support,
  Home, Store, Factory, Domain, MeetingRoom, Cottage, Villa,
  AccountBalance, Gavel, Balance, Policy, VerifiedUser, Shield,
  AdminPanelSettings, SupervisedUserCircle, ManageAccounts,
  Contacts, GroupAdd, PersonAdd, PersonOutlined, Badge,
  Assignment, Task, Checklist, Rule, FactCheck, PlaylistAddCheck,
  Schedule, Event, AccessTime, HourglassEmpty, Timer, Update,
  Notifications, NotificationsActive, NotificationsNone,
  Chat, Forum, QuestionAnswer, MarkEmailRead, OutgoingMail,
  Cloud, CloudQueue, CloudDone, Storage, Dns,
  Settings, Build, Construction, Handyman, Tune,
  Insights, Analytics, BarChart, PieChart, ShowChart, Equalizer,
  MonetizationOn, Payments, CreditCard, AccountBalanceWallet, CurrencyExchange,
  ShoppingCart, ShoppingBasket, LocalShipping, DeliveryDining, Warehouse,
  Favorite, ThumbUp, ThumbDown, SentimentSatisfied, EmojiEvents,
  Public, Language, Map, Explore, Navigation, TripOrigin,
  Lightbulb, TipsAndUpdates, AutoAwesome, Extension, Widgets,
  DataObject, Code, Terminal, BugReport, Api,
  ViewList, ViewModule, GridView, Apps, MoreHoriz,
  Link, OpenInNew, Launch, Input, Output,
  FilterList, Sort, Search, FindInPage, ManageSearch,
  EditNote, Draw, Brush, ColorLens, Palette,
} from '@mui/icons-material'
import { useApi, apiPost, apiPut, apiDelete, fetchObjectSchema } from '../../api/client'
import { createField, updateField, deleteField, sortFields, type FieldRow } from '../../api/fields'
import { ConfirmDialog } from '../../components/shared/ConfirmDialog'
import { useToastStore } from '../../stores/toast.store'
import type { ApiResponse, FieldType, FieldOption, LookupConfig } from '@crm/shared'

export const ICON_OPTIONS = [
  { value: 'Business', label: 'Business', Component: Business },
  { value: 'People', label: 'People', Component: People },
  { value: 'Person', label: 'Person', Component: Person },
  { value: 'ShoppingBag', label: 'Shopping Bag', Component: ShoppingBag },
  { value: 'Work', label: 'Work', Component: Work },
  { value: 'Apartment', label: 'Apartment', Component: Apartment },
  { value: 'Flag', label: 'Flag', Component: Flag },
  { value: 'LocalOffer', label: 'Local Offer', Component: LocalOffer },
  { value: 'Campaign', label: 'Campaign', Component: Campaign },
  { value: 'Handshake', label: 'Handshake', Component: Handshake },
  { value: 'Star', label: 'Star', Component: Star },
  { value: 'Inventory', label: 'Inventory', Component: Inventory },
  { value: 'AttachMoney', label: 'Attach Money', Component: AttachMoney },
  { value: 'LocationOn', label: 'Location On', Component: LocationOn },
  { value: 'Phone', label: 'Phone', Component: Phone },
  { value: 'Email', label: 'Email', Component: Email },
  { value: 'CalendarToday', label: 'Calendar', Component: CalendarToday },
  { value: 'Description', label: 'Description', Component: Description },
  { value: 'Security', label: 'Security', Component: Security },
  { value: 'Dashboard', label: 'Dashboard', Component: Dashboard },
  { value: 'Groups', label: 'Groups', Component: Groups },
  { value: 'TrendingUp', label: 'Trending Up', Component: TrendingUp },
  { value: 'Category', label: 'Category', Component: Category },
  { value: 'Receipt', label: 'Receipt', Component: Receipt },
  { value: 'Support', label: 'Support', Component: Support },
  { value: 'Home', label: 'Home', Component: Home },
  { value: 'Store', label: 'Store', Component: Store },
  { value: 'Factory', label: 'Factory', Component: Factory },
  { value: 'Domain', label: 'Domain', Component: Domain },
  { value: 'MeetingRoom', label: 'Meeting Room', Component: MeetingRoom },
  { value: 'Cottage', label: 'Cottage', Component: Cottage },
  { value: 'Villa', label: 'Villa', Component: Villa },
  { value: 'AccountBalance', label: 'Account Balance', Component: AccountBalance },
  { value: 'Gavel', label: 'Gavel', Component: Gavel },
  { value: 'Balance', label: 'Balance', Component: Balance },
  { value: 'Policy', label: 'Policy', Component: Policy },
  { value: 'VerifiedUser', label: 'Verified User', Component: VerifiedUser },
  { value: 'Shield', label: 'Shield', Component: Shield },
  { value: 'AdminPanelSettings', label: 'Admin Panel', Component: AdminPanelSettings },
  { value: 'SupervisedUserCircle', label: 'Supervised User', Component: SupervisedUserCircle },
  { value: 'ManageAccounts', label: 'Manage Accounts', Component: ManageAccounts },
  { value: 'Contacts', label: 'Contacts', Component: Contacts },
  { value: 'GroupAdd', label: 'Group Add', Component: GroupAdd },
  { value: 'PersonAdd', label: 'Person Add', Component: PersonAdd },
  { value: 'PersonOutlined', label: 'Person Outline', Component: PersonOutlined },
  { value: 'Badge', label: 'Badge', Component: Badge },
  { value: 'Assignment', label: 'Assignment', Component: Assignment },
  { value: 'Task', label: 'Task', Component: Task },
  { value: 'Checklist', label: 'Checklist', Component: Checklist },
  { value: 'Rule', label: 'Rule', Component: Rule },
  { value: 'FactCheck', label: 'Fact Check', Component: FactCheck },
  { value: 'PlaylistAddCheck', label: 'Playlist Check', Component: PlaylistAddCheck },
  { value: 'Schedule', label: 'Schedule', Component: Schedule },
  { value: 'Event', label: 'Event', Component: Event },
  { value: 'AccessTime', label: 'Access Time', Component: AccessTime },
  { value: 'HourglassEmpty', label: 'Hourglass', Component: HourglassEmpty },
  { value: 'Timer', label: 'Timer', Component: Timer },
  { value: 'Update', label: 'Update', Component: Update },
  { value: 'Notifications', label: 'Notifications', Component: Notifications },
  { value: 'NotificationsActive', label: 'Notifications Active', Component: NotificationsActive },
  { value: 'NotificationsNone', label: 'Notifications None', Component: NotificationsNone },
  { value: 'Chat', label: 'Chat', Component: Chat },
  { value: 'Forum', label: 'Forum', Component: Forum },
  { value: 'QuestionAnswer', label: 'Q&A', Component: QuestionAnswer },
  { value: 'MarkEmailRead', label: 'Email Read', Component: MarkEmailRead },
  { value: 'OutgoingMail', label: 'Outgoing Mail', Component: OutgoingMail },
  { value: 'Cloud', label: 'Cloud', Component: Cloud },
  { value: 'CloudQueue', label: 'Cloud Queue', Component: CloudQueue },
  { value: 'CloudDone', label: 'Cloud Done', Component: CloudDone },
  { value: 'Storage', label: 'Storage', Component: Storage },
  { value: 'Dns', label: 'DNS', Component: Dns },
  { value: 'Build', label: 'Build', Component: Build },
  { value: 'Construction', label: 'Construction', Component: Construction },
  { value: 'Handyman', label: 'Handyman', Component: Handyman },
  { value: 'Tune', label: 'Tune', Component: Tune },
  { value: 'Insights', label: 'Insights', Component: Insights },
  { value: 'Analytics', label: 'Analytics', Component: Analytics },
  { value: 'BarChart', label: 'Bar Chart', Component: BarChart },
  { value: 'PieChart', label: 'Pie Chart', Component: PieChart },
  { value: 'ShowChart', label: 'Show Chart', Component: ShowChart },
  { value: 'Equalizer', label: 'Equalizer', Component: Equalizer },
  { value: 'MonetizationOn', label: 'Monetization', Component: MonetizationOn },
  { value: 'Payments', label: 'Payments', Component: Payments },
  { value: 'CreditCard', label: 'Credit Card', Component: CreditCard },
  { value: 'AccountBalanceWallet', label: 'Wallet', Component: AccountBalanceWallet },
  { value: 'CurrencyExchange', label: 'Currency Exchange', Component: CurrencyExchange },
  { value: 'ShoppingCart', label: 'Shopping Cart', Component: ShoppingCart },
  { value: 'ShoppingBasket', label: 'Shopping Basket', Component: ShoppingBasket },
  { value: 'LocalShipping', label: 'Shipping', Component: LocalShipping },
  { value: 'DeliveryDining', label: 'Delivery', Component: DeliveryDining },
  { value: 'Warehouse', label: 'Warehouse', Component: Warehouse },
  { value: 'Favorite', label: 'Favorite', Component: Favorite },
  { value: 'ThumbUp', label: 'Thumb Up', Component: ThumbUp },
  { value: 'ThumbDown', label: 'Thumb Down', Component: ThumbDown },
  { value: 'SentimentSatisfied', label: 'Satisfied', Component: SentimentSatisfied },
  { value: 'EmojiEvents', label: 'Events', Component: EmojiEvents },
  { value: 'Public', label: 'Public', Component: Public },
  { value: 'Language', label: 'Language', Component: Language },
  { value: 'Map', label: 'Map', Component: Map },
  { value: 'Explore', label: 'Explore', Component: Explore },
  { value: 'Navigation', label: 'Navigation', Component: Navigation },
  { value: 'Lightbulb', label: 'Lightbulb', Component: Lightbulb },
  { value: 'TipsAndUpdates', label: 'Tips & Updates', Component: TipsAndUpdates },
  { value: 'AutoAwesome', label: 'Auto Awesome', Component: AutoAwesome },
  { value: 'Extension', label: 'Extension', Component: Extension },
  { value: 'Widgets', label: 'Widgets', Component: Widgets },
  { value: 'DataObject', label: 'Data Object', Component: DataObject },
  { value: 'Code', label: 'Code', Component: Code },
  { value: 'Terminal', label: 'Terminal', Component: Terminal },
  { value: 'BugReport', label: 'Bug Report', Component: BugReport },
  { value: 'Api', label: 'API', Component: Api },
  { value: 'ViewList', label: 'View List', Component: ViewList },
  { value: 'ViewModule', label: 'View Module', Component: ViewModule },
  { value: 'GridView', label: 'Grid View', Component: GridView },
  { value: 'Apps', label: 'Apps', Component: Apps },
  { value: 'Link', label: 'Link', Component: Link },
  { value: 'OpenInNew', label: 'Open In New', Component: OpenInNew },
  { value: 'FilterList', label: 'Filter', Component: FilterList },
  { value: 'Sort', label: 'Sort', Component: Sort },
  { value: 'Search', label: 'Search', Component: Search },
  { value: 'EditNote', label: 'Edit Note', Component: EditNote },
  { value: 'Draw', label: 'Draw', Component: Draw },
  { value: 'Brush', label: 'Brush', Component: Brush },
  { value: 'Palette', label: 'Palette', Component: Palette },
]

export function getIconComponent(iconName: string | null | undefined) {
  const found = ICON_OPTIONS.find((o) => o.value === iconName)
  return found?.Component ?? Business
}

interface ObjectRow {
  id: string
  name: string
  label: string
  label_plural: string
  icon: string | null
  is_system: number
  is_active: number
}

const FIELD_TYPES: { value: FieldType; label: string }[] = [
  { value: 'text', label: 'Text' },
  { value: 'long_text', label: 'Long Text' },
  { value: 'number', label: 'Number' },
  { value: 'boolean', label: 'Boolean' },
  { value: 'indicator', label: 'Indicator' },
  { value: 'date', label: 'Date' },
  { value: 'datetime', label: 'Date Time' },
  { value: 'enum', label: 'Enum' },
  { value: 'select', label: 'Select' },
  { value: 'multi_select', label: 'Multi Select' },
  { value: 'lookup', label: 'Lookup' },
  { value: 'multi_lookup', label: 'Multi Lookup' },
  { value: 'json', label: 'JSON' },
]

interface FieldFormData {
  name: string
  label: string
  type: FieldType
  is_required: boolean
  is_indexed: boolean
  default_value: string
  options: FieldOption[]
  config: LookupConfig | null
  sort_order: number
  section: string
  is_quick_search: boolean
  is_owl_visible: boolean
  is_template_visible: boolean
}

const defaultFieldForm: FieldFormData = {
  name: '',
  label: '',
  type: 'text',
  is_required: false,
  is_indexed: false,
  default_value: '',
  options: [],
  config: null,
  sort_order: 0,
  section: '',
  is_quick_search: false,
  is_owl_visible: true,
  is_template_visible: false,
}

function parseFieldOptions(raw: string | null | undefined): FieldOption[] {
  if (!raw) return []
  try {
    const parsed = JSON.parse(raw)
    if (Array.isArray(parsed)) return parsed
    if (parsed?.options && Array.isArray(parsed.options)) return parsed.options
    return []
  } catch {
    return []
  }
}

function parseFieldConfig(raw: string | null | undefined): LookupConfig | null {
  if (!raw) return null
  try {
    return JSON.parse(raw) as LookupConfig
  } catch {
    return null
  }
}

export function ObjectManagement() {
  const { data, mutate } = useApi<ApiResponse<ObjectRow[]>>('/objects')
  const objects = data?.data ?? []
  const toast = useToastStore()

  const [dialogOpen, setDialogOpen] = useState(false)
  const [editObj, setEditObj] = useState<ObjectRow | null>(null)
  const [form, setForm] = useState({ name: '', label: '', label_plural: '', icon: '' })
  const [saving, setSaving] = useState(false)

  const [expandedObjectId, setExpandedObjectId] = useState<string | null>(null)
  const [fieldsData, setFieldsData] = useState<FieldRow[]>([])
  const [fieldsLoading, setFieldsLoading] = useState(false)
  const [fieldDialogOpen, setFieldDialogOpen] = useState(false)
  const [editField, setEditField] = useState<FieldRow | null>(null)
  const [fieldForm, setFieldForm] = useState<FieldFormData>({ ...defaultFieldForm })
  const [fieldSaving, setFieldSaving] = useState(false)
  const [fieldError, setFieldError] = useState('')
  const [deleteObjConfirm, setDeleteObjConfirm] = useState<string | null>(null)
  const [deleteFieldConfirm, setDeleteFieldConfirm] = useState<string | null>(null)

  const dragIndex = useRef<number | null>(null)
  const dragOverIndex = useRef<number | null>(null)

  const openCreate = () => {
    setEditObj(null)
    setForm({ name: '', label: '', label_plural: '', icon: '' })
    setDialogOpen(true)
  }

  const openEdit = (obj: ObjectRow) => {
    setEditObj(obj)
    setForm({ name: obj.name, label: obj.label, label_plural: obj.label_plural, icon: obj.icon ?? '' })
    setDialogOpen(true)
  }

  const handleSave = useCallback(async () => {
    setSaving(true)
    try {
      if (editObj) {
        await apiPut(`/objects/${editObj.id}`, { label: form.label, label_plural: form.label_plural, icon: form.icon || null })
        toast.success('对象已更新')
      } else {
        await apiPost('/objects', form)
        toast.success('对象已创建')
      }
      mutate()
      setDialogOpen(false)
    } catch (err) {
      toast.error(err instanceof Error ? err.message : '保存失败')
    } finally {
      setSaving(false)
    }
  }, [editObj, form, mutate, toast])

  const handleDelete = useCallback(async (id: string) => {
    try {
      await apiDelete(`/objects/${id}`)
      mutate()
      toast.success('对象已删除')
      if (expandedObjectId === id) setExpandedObjectId(null)
    } catch (err) {
      toast.error(err instanceof Error ? err.message : '删除失败')
    }
    setDeleteObjConfirm(null)
  }, [mutate, expandedObjectId, toast])

  const toggleExpand = useCallback(async (objId: string) => {
    if (expandedObjectId === objId) {
      setExpandedObjectId(null)
      setFieldsData([])
      return
    }
    setExpandedObjectId(objId)
    setFieldsLoading(true)
    try {
      const schemaRes = await fetchObjectSchema(objId)
      setFieldsData((schemaRes.data?.fields ?? []) as unknown as FieldRow[])
    } catch {
      setFieldsData([])
    } finally {
      setFieldsLoading(false)
    }
  }, [expandedObjectId])

  const openCreateField = () => {
    setEditField(null)
    setFieldForm({ ...defaultFieldForm })
    setFieldError('')
    setFieldDialogOpen(true)
  }

  const openEditField = (field: FieldRow) => {
    setEditField(field)
    setFieldForm({
      name: field.name,
      label: field.label,
      type: field.type,
      is_required: !!field.is_required,
      is_indexed: !!field.is_indexed,
      default_value: field.default_value ?? '',
      options: parseFieldOptions(field.options),
      config: parseFieldConfig(field.config),
      sort_order: field.sort_order ?? 0,
      section: field.section ?? '',
      is_quick_search: !!field.is_quick_search,
      is_owl_visible: field.is_owl_visible !== 0,
      is_template_visible: field.is_template_visible !== 0,
    })
    setFieldError('')
    setFieldDialogOpen(true)
  }

  const handleFieldSave = useCallback(async () => {
    if (!expandedObjectId) return
    setFieldSaving(true)
    setFieldError('')
    try {
      if (editField) {
        const payload: Record<string, unknown> = {
          label: fieldForm.label,
          is_required: fieldForm.is_required,
          is_indexed: fieldForm.is_indexed,
          default_value: fieldForm.default_value || null,
          sort_order: fieldForm.sort_order,
          section: fieldForm.section || null,
          is_quick_search: fieldForm.is_quick_search,
          is_owl_visible: fieldForm.is_owl_visible,
          is_template_visible: fieldForm.is_template_visible,
        }
        if (['enum', 'select', 'multi_select'].includes(fieldForm.type)) {
          payload.options = fieldForm.options
        }
        if (['lookup', 'multi_lookup'].includes(fieldForm.type) && fieldForm.config) {
          payload.config = fieldForm.config
        }
        await updateField(expandedObjectId, editField.field_id, payload)
      } else {
        const payload: Record<string, unknown> = {
          name: fieldForm.name,
          label: fieldForm.label,
          type: fieldForm.type,
          is_required: fieldForm.is_required,
          is_indexed: fieldForm.is_indexed,
          default_value: fieldForm.default_value || null,
          sort_order: fieldForm.sort_order,
          section: fieldForm.section || null,
          is_quick_search: fieldForm.is_quick_search,
          is_owl_visible: fieldForm.is_owl_visible,
          is_template_visible: fieldForm.is_template_visible,
        }
        if (['enum', 'select', 'multi_select'].includes(fieldForm.type)) {
          payload.options = fieldForm.options.length > 0 ? fieldForm.options : [{ label: 'Option 1', value: 'option_1' }]
        }
        if (['lookup', 'multi_lookup'].includes(fieldForm.type) && fieldForm.config) {
          payload.config = fieldForm.config
        }
        await createField(expandedObjectId, payload as Parameters<typeof createField>[1])
      }
      setFieldDialogOpen(false)
      toggleExpand(expandedObjectId)
    } catch (err) {
      setFieldError(err instanceof Error ? err.message : 'Failed to save field')
    } finally {
      setFieldSaving(false)
    }
  }, [expandedObjectId, editField, fieldForm, toggleExpand])

  const handleFieldDelete = useCallback(async (fieldId: string) => {
    if (!expandedObjectId) return
    try {
      await deleteField(expandedObjectId, fieldId)
      toggleExpand(expandedObjectId)
    } catch { /* ignore */ }
    setDeleteFieldConfirm(null)
  }, [expandedObjectId, toggleExpand])

  const handleDragStart = useCallback((index: number) => {
    dragIndex.current = index
  }, [])

  const handleDragOver = useCallback((e: React.DragEvent, index: number) => {
    e.preventDefault()
    dragOverIndex.current = index
  }, [])

  const handleDrop = useCallback(async (index: number) => {
    if (dragIndex.current === null || dragIndex.current === index) {
      dragIndex.current = null
      return
    }
    const updated = [...fieldsData]
    const [moved] = updated.splice(dragIndex.current, 1)
    updated.splice(index, 0, moved)
    const reordered = updated.map((f, i) => ({ ...f, sort_order: i }))
    setFieldsData(reordered)
    dragIndex.current = null
    try {
      await sortFields(expandedObjectId!, reordered.map((f) => ({ field_id: f.field_id, sort_order: f.sort_order })))
    } catch { /* ignore */ }
  }, [fieldsData, expandedObjectId])

  const isOptionsType = ['enum', 'select', 'multi_select'].includes(fieldForm.type)
  const isLookupType = ['lookup', 'multi_lookup'].includes(fieldForm.type)

  const addOption = () => setFieldForm((p) => ({
    ...p,
    options: [...p.options, { label: '', value: '' }],
  }))

  const removeOption = (index: number) => setFieldForm((p) => ({
    ...p,
    options: p.options.filter((_, i) => i !== index),
  }))

  const updateOption = (index: number, key: 'label' | 'value', val: string) => setFieldForm((p) => ({
    ...p,
    options: p.options.map((o, i) => (i === index ? { ...o, [key]: val } : o)),
  }))

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h6">Objects</Typography>
        <Button variant="contained" size="small" startIcon={<Add />} onClick={openCreate}>New Object</Button>
      </Box>

      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 700, width: 40 }} />
              <TableCell sx={{ fontWeight: 700 }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Label</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Plural</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Type</TableCell>
              <TableCell sx={{ fontWeight: 700, width: 100, whiteSpace: 'nowrap' }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {objects.map((obj) => (
              <>
                <TableRow key={obj.id} hover>
                  <TableCell>
                    <IconButton size="small" onClick={() => toggleExpand(obj.id)}>
                      {expandedObjectId === obj.id ? <ExpandMore fontSize="small" /> : <ChevronRight fontSize="small" />}
                    </IconButton>
                  </TableCell>
                  <TableCell>{obj.name}</TableCell>
                  <TableCell>{obj.label}</TableCell>
                  <TableCell>{obj.label_plural}</TableCell>
                  <TableCell><Chip label={obj.is_system ? 'System' : 'Custom'} size="small" variant="outlined" /></TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>
                    <IconButton size="small" onClick={() => openEdit(obj)}><Edit fontSize="small" /></IconButton>
                    {!obj.is_system && <IconButton size="small" color="error" onClick={() => setDeleteObjConfirm(obj.id)}><Delete fontSize="small" /></IconButton>}
                  </TableCell>
                </TableRow>
                <TableRow key={`${obj.id}-fields`}>
                  <TableCell colSpan={6} sx={{ py: 0, borderBottom: expandedObjectId === obj.id ? undefined : 0 }}>
                    <Collapse in={expandedObjectId === obj.id} unmountOnExit>
                      <Box sx={{ p: 2, bgcolor: 'action.hover' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                          <Typography variant="subtitle2">Fields</Typography>
                          <Button variant="outlined" size="small" startIcon={<Add />} onClick={openCreateField}>
                            Add Field
                          </Button>
                        </Box>
                        {fieldsLoading ? (
                          <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}><CircularProgress size={20} /></Box>
                        ) : fieldsData.length === 0 ? (
                          <Typography variant="body2" color="text.secondary">No fields found</Typography>
                        ) : (
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell sx={{ fontWeight: 700, width: 40 }} />
                                <TableCell sx={{ fontWeight: 700 }}>Name</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Label</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Type</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Required</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>OWL</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Template</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Section</TableCell>
                                <TableCell sx={{ fontWeight: 700, width: 100, whiteSpace: 'nowrap' }} />
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {fieldsData.map((field, index) => (
                                <TableRow
                                  key={field.field_id}
                                  draggable
                                  onDragStart={() => handleDragStart(index)}
                                  onDragOver={(e) => handleDragOver(e, index)}
                                  onDrop={() => handleDrop(index)}
                                  sx={{ cursor: 'grab', '&:hover': { bgcolor: 'action.hover' } }}
                                >
                                  <TableCell>
                                    <DragIndicator sx={{ color: 'text.disabled', fontSize: 18 }} />
                                  </TableCell>
                                  <TableCell>
                                    <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>{field.name}</Typography>
                                  </TableCell>
                                  <TableCell>{field.label}</TableCell>
                                  <TableCell><Chip label={field.type} size="small" variant="outlined" /></TableCell>
                                  <TableCell>{field.is_required ? '✓' : ''}</TableCell>
                                  <TableCell>{field.is_owl_visible !== 0 ? '✓' : ''}</TableCell>
                                  <TableCell>{field.is_template_visible !== 0 ? '✓' : ''}</TableCell>
                                  <TableCell>{field.section || '-'}</TableCell>
                                  <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    <Tooltip title={field.is_system ? 'System field - limited editing' : 'Edit field'}>
                                      <span>
                                        <IconButton size="small" onClick={() => openEditField(field)}>
                                          <Edit fontSize="small" />
                                        </IconButton>
                                      </span>
                                    </Tooltip>
                                    {!field.is_system && (
                                      <IconButton size="small" color="error" onClick={() => setDeleteFieldConfirm(field.field_id)}>
                                        <Delete fontSize="small" />
                                      </IconButton>
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        )}
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editObj ? 'Edit Object' : 'New Object'}</DialogTitle>
        <DialogContent>
          <TextField label="Name" value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} fullWidth size="small" sx={{ mt: 1 }} disabled={!!editObj} />
          <TextField label="Label" value={form.label} onChange={(e) => setForm((p) => ({ ...p, label: e.target.value }))} fullWidth size="small" sx={{ mt: 2 }} />
          <TextField label="Plural Label" value={form.label_plural} onChange={(e) => setForm((p) => ({ ...p, label_plural: e.target.value }))} fullWidth size="small" sx={{ mt: 2 }} />
          <Autocomplete
            size="small"
            options={ICON_OPTIONS}
            getOptionLabel={(opt) => opt.label}
            value={ICON_OPTIONS.find((o) => o.value === form.icon) ?? null}
            onChange={(_, newVal) => setForm((p) => ({ ...p, icon: newVal?.value ?? '' }))}
            isOptionEqualToValue={(opt, val) => opt.value === val.value}
            sx={{ mt: 2 }}
            renderOption={(props, opt) => {
              const IconComp = opt.Component
              return (
                <li {...props}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <IconComp fontSize="small" />
                    {opt.label}
                  </Box>
                </li>
              )
            }}
            renderInput={(params) => (
              <TextField {...params} label="Icon" variant="outlined" />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" disabled={saving}>{saving ? <CircularProgress size={20} /> : 'Save'}</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={fieldDialogOpen} onClose={() => setFieldDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>{editField ? 'Edit Field' : 'New Field'}</DialogTitle>
        <DialogContent>
          {fieldError && <Alert severity="error" sx={{ mb: 2 }}>{fieldError}</Alert>}
          <TextField
            label="Field Name"
            value={fieldForm.name}
            onChange={(e) => setFieldForm((p) => ({ ...p, name: e.target.value }))}
            fullWidth size="small" sx={{ mt: 1 }}
            disabled={!!editField}
            slotProps={{ htmlInput: { pattern: '[a-zA-Z_][a-zA-Z0-9_]*' } }}
          />
          <TextField
            label="Label"
            value={fieldForm.label}
            onChange={(e) => setFieldForm((p) => ({ ...p, label: e.target.value }))}
            fullWidth size="small" sx={{ mt: 2 }}
          />
          <FormControl fullWidth size="small" sx={{ mt: 2 }}>
            <InputLabel>Type</InputLabel>
            <Select
              value={fieldForm.type}
              label="Type"
              onChange={(e) => setFieldForm((p) => ({ ...p, type: e.target.value as FieldType }))}
              disabled={!!editField}
            >
              {FIELD_TYPES.map((ft) => (
                <MenuItem key={ft.value} value={ft.value}>{ft.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box sx={{ display: 'flex', gap: 2, mt: 2, flexWrap: 'wrap' }}>
            <FormControlLabel
              control={<Checkbox checked={fieldForm.is_required} onChange={(e) => setFieldForm((p) => ({ ...p, is_required: e.target.checked }))} />}
              label="Required"
            />
            <FormControlLabel
              control={<Checkbox checked={fieldForm.is_indexed} onChange={(e) => setFieldForm((p) => ({ ...p, is_indexed: e.target.checked }))} />}
              label="Indexed"
            />
            <FormControlLabel
              control={<Checkbox checked={fieldForm.is_quick_search} onChange={(e) => setFieldForm((p) => ({ ...p, is_quick_search: e.target.checked }))} />}
              label="Quick Search"
            />
            <FormControlLabel
              control={<Checkbox checked={fieldForm.is_owl_visible} onChange={(e) => setFieldForm((p) => ({ ...p, is_owl_visible: e.target.checked }))} />}
              label="Add to OWL"
            />
            <FormControlLabel
              control={<Checkbox checked={fieldForm.is_template_visible} onChange={(e) => setFieldForm((p) => ({ ...p, is_template_visible: e.target.checked }))} />}
              label="Add to Template"
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <TextField
              label="Section"
              value={fieldForm.section}
              onChange={(e) => setFieldForm((p) => ({ ...p, section: e.target.value }))}
              size="small" sx={{ flexGrow: 1 }}
            />
            <TextField
              label="Sort Order"
              type="number"
              value={fieldForm.sort_order}
              onChange={(e) => setFieldForm((p) => ({ ...p, sort_order: parseInt(e.target.value) || 0 }))}
              size="small" sx={{ width: 120 }}
            />
          </Box>
          <TextField
            label="Default Value"
            value={fieldForm.default_value}
            onChange={(e) => setFieldForm((p) => ({ ...p, default_value: e.target.value }))}
            fullWidth size="small" sx={{ mt: 2 }}
          />

          {isOptionsType && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>Options</Typography>
              {fieldForm.options.map((opt, i) => (
                <Box key={i} sx={{ display: 'flex', gap: 1, mb: 1, alignItems: 'center' }}>
                  <TextField
                    label="Label" size="small" value={opt.label}
                    onChange={(e) => updateOption(i, 'label', e.target.value)}
                    sx={{ flexGrow: 1 }}
                  />
                  <TextField
                    label="Value" size="small" value={opt.value}
                    onChange={(e) => updateOption(i, 'value', e.target.value)}
                    sx={{ flexGrow: 1 }}
                  />
                  <IconButton size="small" onClick={() => removeOption(i)}>×</IconButton>
                </Box>
              ))}
              <Button size="small" onClick={addOption}>+ Add Option</Button>
            </Box>
          )}

          {isLookupType && (
            <Box sx={{ mt: 2 }}>
              <FormControl fullWidth size="small">
                <InputLabel>Target Object</InputLabel>
                <Select
                  value={fieldForm.config?.target_object_id ?? ''}
                  label="Target Object"
                  onChange={(e) => setFieldForm((p) => ({
                    ...p,
                    config: { ...p.config, target_object_id: e.target.value, relation_type: p.config?.relation_type ?? 'many_to_one', display_field: p.config?.display_field ?? '' },
                  }))}
                  disabled={!!editField}
                >
                  {objects.map((obj) => (
                    <MenuItem key={obj.id} value={obj.id}>{obj.label} ({obj.name})</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFieldDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleFieldSave} variant="contained" disabled={fieldSaving}>
            {fieldSaving ? <CircularProgress size={20} /> : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>

      <ConfirmDialog
        open={deleteObjConfirm !== null}
        title="Delete Object"
        message="Are you sure you want to delete this object? All records and fields will be permanently removed."
        confirmLabel="Delete"
        confirmColor="error"
        onConfirm={() => handleDelete(deleteObjConfirm!)}
        onCancel={() => setDeleteObjConfirm(null)}
      />

      <ConfirmDialog
        open={deleteFieldConfirm !== null}
        title="Delete Field"
        message="Are you sure you want to delete this field? This cannot be undone."
        confirmLabel="Delete"
        confirmColor="error"
        onConfirm={() => handleFieldDelete(deleteFieldConfirm!)}
        onCancel={() => setDeleteFieldConfirm(null)}
      />
    </Box>
  )
}
